import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { releaseTestSpecTargetsSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_stacktrace/qa-operations-core/releasetest-spec-targets/')({
  validateSearch: zodValidator(releaseTestSpecTargetsSearchSchema)
});